import React, { useState } from "react";
import { Fab, Menu, MenuItem, ListItemIcon, ListItemText } from "@mui/material";
import { Globe, Languages } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useRTL } from "../../hooks/useRTL";

const FloatingLanguageToggle = () => {
  const { i18n } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const { isRTL } = useRTL();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLanguageChange = (language) => {
    i18n.changeLanguage(language);
    handleClose();

    // Update document direction for Arabic
    if (language === "ar") {
      document.documentElement.dir = "rtl";
      document.documentElement.lang = "ar";
    } else {
      document.documentElement.dir = "ltr";
      document.documentElement.lang = "en";
    }
  };

  const currentLanguage = i18n.language;

  return (
    <>
      <Fab
        onClick={handleClick}
        sx={{
          position: "fixed",
          top: 20,
          left: isRTL ? 20 : "auto",
          right: isRTL ? "auto" : 20,
          backgroundColor: "#C47D60",
          color: "white",
          zIndex: 1000,
          "&:hover": {
            backgroundColor: "#A65A42",
          },
        }}
        size="medium"
        aria-label="change language"
      >
        <Globe size={20} />
      </Fab>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: isRTL ? "right" : "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: isRTL ? "right" : "left",
        }}
        PaperProps={{
          sx: {
            minWidth: 150,
            "& .MuiMenuItem-root": {
              px: 2,
              py: 1,
            },
          },
        }}
      >
        <MenuItem
          onClick={() => handleLanguageChange("en")}
          selected={currentLanguage === "en"}
        >
          <ListItemIcon>
            <span style={{ fontSize: "16px", fontWeight: "bold" }}>EN</span>
          </ListItemIcon>
          <ListItemText primary="English" />
        </MenuItem>

        <MenuItem
          onClick={() => handleLanguageChange("ar")}
          selected={currentLanguage === "ar"}
        >
          <ListItemIcon>
            <span style={{ fontSize: "16px", fontWeight: "bold" }}>AR</span>
          </ListItemIcon>
          <ListItemText primary="العربية" />
        </MenuItem>
      </Menu>
    </>
  );
};

export default FloatingLanguageToggle;
